<template>
	<Col>
		<SharedGroupItemHeader :isOpen.sync="isOpen" :loadingVisibilityChange.sync="loadingVisibilityChange" v-bind="sectionProps" />
		<v-expand-transition>
			<SharedGroupItemContent
				v-if="isOpen"
				v-bind="sectionProps"
				:nestedLevelIndex="nestedLevelIndex"
				:class="[nestedLevelIndex < 3 ? 'pl-12' : nestedLevelIndex < 8 ? 'pl-2' : 'pl-0']"
			/>
		</v-expand-transition>
	</Col>
</template>
<script>
import SharedGroupItemContent from '@/components/dialogs/ShareFeatureDialog/ExistingShareList/SharedGroupItem/SharedGroupItemContent.vue';
import SharedGroupItemHeader from '@/components/dialogs/ShareFeatureDialog/ExistingShareList/SharedGroupItem/SharedGroupItemHeader.vue';
import { OPTIONS_MAP } from '@/components/dialogs/ShareModuleDialog/share-module-dialog.const.js';
export default {
	name: 'SharedGroupItem',
	components: { SharedGroupItemHeader, SharedGroupItemContent },
	props: {
		group: { type: Object },
		workflow: { type: Object },
		sharedData: { type: Array },
		usersSharedData: { type: Array },
		nestedLevelIndex: { type: Number },
		hideVisibilityStatus: { type: Boolean },
		isNestedInsideAnotherGroup: { type: Boolean },
	},
	computed: {
		groupShareData() {
			return this.sharedData?.find((g) => g.id === this.group.id);
		},
		isVisible() {
			return this.groupShareData.is_on;
		},
		isLocked() {
			return this.groupShareData.role === OPTIONS_MAP.CAN_USE_ENFORCED;
		},
		sectionProps() {
			return {
				group: this.group,
				isLocked: this.isLocked,
				workflow: this.workflow,
				isVisible: this.isVisible,
				sharedData: this.sharedData,
				usersSharedData: this.usersSharedData,
				hideVisibilityStatus: this.hideVisibilityStatus,
				isNestedInsideAnotherGroup: this.isNestedInsideAnotherGroup,
			};
		},
	},
	data() {
		return {
			isOpen: false,
			loadingVisibilityChange: false,
		};
	},
};
</script>
<style scoped lang="scss"></style>
